import React from 'react';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';
import { ListDropDown } from 'components';
import { DueDateOption } from 'containers/settings/invoice-settings/invoiceSettings.model';
import { DUE_DATE_OPTIONS } from 'containers/settings/constants';

interface DueDateSettingSectionProps {
  selectedDueDate: DueDateOption | null;
  onDueDateChange: (dueDate: DueDateOption) => void;
  isDisabled?: boolean;
}

const DueDateSettingSection: React.FC<DueDateSettingSectionProps> = ({
  selectedDueDate,
  onDueDateChange,
  isDisabled = false
}) => {
  const handleDueDateChange = (dueDate: DueDateOption) => {
    onDueDateChange(dueDate);
  };

  return (
    <div
      className={twMerge(
        classnames({
          'pointer-events-none opacity-50': isDisabled
        })
      )}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-xl font-bold text-primaryText">Due date</div>
          <div className="mt-2 text-17px font-normal text-primaryText">
            Set a default due date that will be applied to all new invoices. You can override it while creating or
            editing an invoice.
          </div>
        </div>
        <div className="ml-6 w-[200px]">
          <ListDropDown
            id="due-date-dropdown"
            selectedItem={selectedDueDate}
            items={DUE_DATE_OPTIONS}
            setSelectedItem={handleDueDateChange}
            disabled={isDisabled}
            buttonStyles="bg-secondaryBtn text-sbase font-medium h-10 py-2 rounded-md shadow-sm"
            itemStyle="hover:bg-highlightGray"
            spanStyles="text-headingGray"
            placeholder="Due date"
            idKey="id"
            nameKey="name"
            buttonLabelKey="btnLabel"
          />
        </div>
      </div>
    </div>
  );
};

export default DueDateSettingSection;
